import { AppState } from "src/app/@store/app.reducers";
import * as comlWeb from './complemento-web.actions';
import { createReducer, on } from "@ngrx/store";
import { ComplementoWebState } from "./complemento-web.models";


export interface AppStateComplementoWeb extends AppState {
    complementoWeb: ComplementoWebState;
}

const ComplementoWebInitState: ComplementoWebState = {
    siniestro: null,
    perfilAdministrador: null,
    perfil: null,
    detalleSiniestro: null,
    catalogos: {
        consultaSexo: [],
        consultaTipoPerdida: [],
        consultaTipoEstimacion: [],
        consultaTradicionalTipo: [],
        consultaSubtipoUbicaciones: [],
        consultaEstatusLesionado: [],
        consultaTipoGrua: [],
        consultaEventoServicio: [],
        consultaEstatusConcepto: [],
        consultaEstatusAbogado: [],
        consultaTipoUbicaciones: [],
        consultaTipoSiniestro: [],
        consultaPaises: [],
        consultaTiposRobo: [],
        consultaTipoPase: [],
        consultaTipoServicios: [],
    },
    catalogosTercero: {
        consultaTipoTercero: [],
        consultaTipoPersona: [],
        consultaCoberturas: [],
        consultaColores: [],
        consultaCompanias: [],
        consultaEstatus: [],
        consultaCategorias: [],
    },
    loaded: false,
    loading: false,
    error: null
};

const _complementoWebReducer = createReducer(ComplementoWebInitState,
    on(comlWeb.SolicitudCatalogosDetalleComplementoAction, ((state,) => {
        return {
            ...state,
            loading: true,
        };
    })),

    on(comlWeb.EstablecerCatalogosDetalleResultComplementoAction, ((state, detalleComplemento) => {
        return {
            ...state,
            catalogos: {
                consultaSexo: [...detalleComplemento.detalleComplemento.consultaSexo],
                consultaTipoPerdida: [...detalleComplemento.detalleComplemento.consultaTipoPerdida],
                consultaTipoEstimacion: [...detalleComplemento.detalleComplemento.consultaTipoEstimacion],
                consultaSubtipoUbicaciones: [...detalleComplemento.detalleComplemento.consultaSubtipoUbicaciones],
                consultaEstatusLesionado: [...detalleComplemento.detalleComplemento.consultaEstatusLesionado],
                consultaTradicionalTipo: [...detalleComplemento.detalleComplemento.consultaTradicionalTipo],
                consultaTipoGrua: [...detalleComplemento.detalleComplemento.consultaTipoGrua],
                consultaEventoServicio: [...detalleComplemento.detalleComplemento.consultaEventoServicio],
                consultaEstatusConcepto: [...detalleComplemento.detalleComplemento.consultaEstatusConcepto],
                consultaEstatusAbogado: [...detalleComplemento.detalleComplemento.consultaEstatusAbogado],
                consultaTipoUbicaciones: [...detalleComplemento.detalleComplemento.consultaTipoUbicaciones],
                consultaTipoSiniestro: [...detalleComplemento.detalleComplemento.consultaTipoSiniestro],
                consultaPaises: [...detalleComplemento.detalleComplemento.consultaPaises],
                consultaTiposRobo: [...detalleComplemento.detalleComplemento.consultaTiposRobo],
                consultaTipoPase: [...detalleComplemento.detalleComplemento.consultaTipoPase],
                consultaTipoServicios: [...detalleComplemento.detalleComplemento.consultaTipoServicios],
            },
            loading: false,
        };
    })),

    on(comlWeb.SolicitudCatalogosTerceroDetalleComplementoAction, ((state,) => {
        return {
            ...state,
            loading: true,
        };
    })),

    on(comlWeb.EstablecerCatalogosTerceroDetalleResultComplementoAction, ((state, detalleComplemento) => {
        return {
            ...state,
            catalogosTercero: {
                consultaTipoTercero: detalleComplemento.detalleComplemento.consultaTipoTercero,
                consultaTipoPersona: detalleComplemento.detalleComplemento.consultaTipoPersona,
                consultaCoberturas: detalleComplemento.detalleComplemento.consultaCoberturas,
                consultaColores: detalleComplemento.detalleComplemento.consultaColores,
                consultaCompanias: detalleComplemento.detalleComplemento.consultaCompanias,
                consultaEstatus: detalleComplemento.detalleComplemento.consultaEstatus,
                consultaCategorias: detalleComplemento.detalleComplemento.consultaCategorias,
            },
            loading: false,
        };
    })),

    on(comlWeb.EstablecerResultDetalleComplementoSVAction, ((state, { detalleComplemento }) => {
        return {
            ...state,
            siniestro: detalleComplemento.siniestroCompleto,
            perfilAdministrador: detalleComplemento.perfilAdministrador,
            perfil: detalleComplemento.perfil,
            detalleSiniestro: detalleComplemento,
            loading: false,
        };
    })),

    on(comlWeb.ComplementoWebFailAction, ((state, { payload }) => {
        return {
            ...state,
            loading: false,
            error: payload
        };
    })),
)

export function complementoWebReducer(state: any, action: any) {
    return _complementoWebReducer(state, action);
}